import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./finance.css";

const BankAccountPage = lazy(() => import("./bank").then((m) => ({ default: m.BankAccountPage })));
const BankAccountsPage = lazy(() => import("./bank").then((m) => ({ default: m.BankAccountsPage })));
const BillPage = lazy(() => import("./docs").then((m) => ({ default: m.BillPage })));
const BillsPage = lazy(() => import("./docs").then((m) => ({ default: m.BillsPage })));
const InvoicePage = lazy(() => import("./docs").then((m) => ({ default: m.InvoicePage })));
const InvoicesPage = lazy(() => import("./docs").then((m) => ({ default: m.InvoicesPage })));
const FinancePage = lazy(() => import("./overview").then((m) => ({ default: m.FinancePage })));
const FinanceSetupPage = lazy(() => import("./overview").then((m) => ({ default: m.FinanceSetupPage })));
const ProfitLossPage = lazy(() => import("./reports").then((m) => ({ default: m.ProfitLossPage })));
const SpendPage = lazy(() => import("./reports").then((m) => ({ default: m.SpendPage })));
const FinanceSettings = lazy(() => import("./settings").then((m) => ({ default: m.FinanceSettings })));

/** Finance: invoices, bills, bank accounts and the numbers, in the business's own books. */

export const routes: SolutionRoute[] = [
  { solution: "finance", path: "finance", element: <FinancePage /> },
  { solution: "finance", path: "finance/setup", element: <FinanceSetupPage /> },
  { solution: "finance", path: "finance/invoices", element: <InvoicesPage /> },
  { solution: "finance", path: "finance/invoices/:id", element: <InvoicePage /> },
  { solution: "finance", path: "finance/bills", element: <BillsPage /> },
  { solution: "finance", path: "finance/bills/:id", element: <BillPage /> },
  { solution: "finance", path: "finance/bank", element: <BankAccountsPage /> },
  { solution: "finance", path: "finance/bank/:id", element: <BankAccountPage /> },
  { solution: "finance", path: "finance/profit-and-loss", element: <ProfitLossPage /> },
  { solution: "finance", path: "finance/spend", element: <SpendPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "finance", key: "finance", label: "Finance", icon: Icon.bank, need: "finance.view", Component: FinanceSettings }];

export const nav: NavItem = {
  to: "/finance",
  label: "Finance",
  icon: Icon.bank,
  solution: "finance",
  need: "finance.view",
  subs: [
    { to: "/finance/invoices", label: "Invoices" },
    { to: "/finance/bills", label: "Bills" },
    { to: "/finance/bank", label: "Bank accounts" },
    { to: "/finance/profit-and-loss", label: "Profit and loss" },
    { to: "/finance/spend", label: "Spend" },
  ],
};
